<template>
    <div class="compare-well-checkbox" @click.stop.prevent="checkWell">
        <i class="fa fa-circle-o unchecked" />

        <i
            v-if="selected"
            class="fa fa-circle checked"
            :title="$translate('remove_from_comparison')"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'CompareWellCheckbox',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedForComparison: state => state.timelapse.selectedForComparison
        }),
        selected() {
            return this.selectedForComparison.includes(this.well._id)
        }
    },
    methods: {
        checkWell() {
            this.$store.dispatch('timelapse/addRemoveFromWellComparison', {
                wellId: this.well._id,
                add: !this.selected
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.compare-well-checkbox {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0.25rem;

    .fa-circle-o {
        font-size: 14pt;
    }
    .fa-circle {
        position: absolute;
        font-size: 8pt;
        color: $blue;
    }
}
</style>
